import React from 'react';
// types
import PropTypes from 'prop-types';

// mui libs
import { FormControl, FormHelperText } from 'material-ui/Form';
import MaterialTextField from 'material-ui/TextField';

// icons
import { FiSearch } from 'react-icons/fi';

const SearchOffers = ({
  input,
  label,
  helperText,
  meta: { touched, error },
  ...custom
}) => (
  <FormControl error={Boolean(touched && error)}>
    {helperText && (
      <div>
        <FormHelperText>{helperText}</FormHelperText>
        {label && <br />}
      </div>
    )}
    <MaterialTextField
      label={label}
      error={Boolean(touched && error)}
      {...input}
      {...custom}
      InputProps={{
        style: {
          alignItems: 'center',
        },
        endAdornment: <FiSearch size={25} />,
      }}
    />

    {touched && error && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

SearchOffers.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.node,
  helperText: PropTypes.string,
  meta: PropTypes.object.isRequired,
};

SearchOffers.defaultProps = {
  helperText: null,
  label: null,
};

export default SearchOffers;



// WEBPACK FOOTER //
// ./src/components/Dashboard/SearchOffers.js